<p-card class="px-3 py-2 block">
  <p-tabView
    [(activeIndex)]="activeIndex"
    (onChange)="tabularRouting($event)"
    [ngClass]="{ 'transparent-nav': isTransparentBG }"
    (activeIndexChange)="tabChangeHandler($event)"
  >
    <ng-container *ngIf="menuTabs.length">
      <p-tabPanel *ngFor="let tab of menuTabs">
        <ng-template pTemplate="header"
          ><span [class]="tab.class">{{ tab.tabLabel }}</span></ng-template
        >
      </p-tabPanel>
    </ng-container>
  </p-tabView>
</p-card>
